/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["app-company-balances-residual-vacation .non-cursor{cursor:default;background:#fff;opacity:.7}app-company-balances-residual-vacation .non-diamond-inner-wrap{background-image:unset;text-align:center;font-size:18px;width:70%;margin:auto;cursor:default;opacity:1}"];
export { styles as styles };
